<div fxLayout="row" class="inputs" >
    <mat-form-field *ngIf="exibirBusca && !habilitarBuscaNoBackend">
      <input matInput (keyup)="aplicarFiltroDeBusca($event)" placeholder="Pesquisar">
    </mat-form-field>

    <mat-form-field  *ngIf="exibirBusca && habilitarBuscaNoBackend" [formGroup]="form">
      <input matInput formControlName="filtro" placeholder="Pesquisar">
    </mat-form-field>

    <a class="btn btn-filtro" title="Buscar" *ngIf="exibirBusca && habilitarBuscaNoBackend"
      (click)="aplicarFiltroDeBusca($event)">
      <icons-primecap name="pesquisa"></icons-primecap>
    </a>

    <a class="btn btn-filtro" title="Limpar Filtro" *ngIf="exibirBusca && habilitarBuscaNoBackend"
      (click)="limparFiltro()">
      <icons-primecap name="lixeira"></icons-primecap>
    </a>

    <button-primecap *ngIf="exibirCriacao" class="m-2 float-right"
      label="Adicionar"
      buttonClass="terciario-button"
      [disabled]="false"
      [icon]="true"
      nomeIcon="plus"
      (clickButton)="executarAcaoCrud(acoesCrud.Adicionar, {})"
    ></button-primecap>
</div>

<multiplos-filtros *ngIf="exibirFiltros"></multiplos-filtros>

<table mat-table [dataSource]="dataSource" matSort>


    <ng-container *ngFor="let coluna of definicaoColuna" [matColumnDef]="coluna.prop">

        <!--
            coluna com os botões de crud, ativação, desativação e dashboard
            as input e output properties recebidas aqui são passadas para as
            input e output properties do componente da coluna de ações
        -->
        <ng-container *ngIf="coluna.tipo === TipoColuna.Acoes">
            <td mat-cell *matCellDef="let objeto">
                <app-coluna-acoes-crud
                    [objeto]="objeto"
                    [exibirEdicao]="exibirEdicao"
                    [exibirDelecao]="exibirDelecao"
                    [exibirDetalhes]="exibirDetalhes"
                    [exibirDashboard]="exibirDashboard"
                    [exibirAbrirPagina]="exibirAbrirPagina"
                    [tituloAbrirPagina]="tituloAbrirPagina"
                    [iconeAbrirPagina]="iconeAbrirPagina"
                    [exibirRecusarInvestimento]="exibirRecusarInvestimento"
                    [exibirAssinarInvestimento]="exibirAssinarInvestimento"
                    [exibirConfirmarPagamento]="exibirConfirmarPagamento"
                    [exibirAnalisarInvestimento]="exibirAnalisarInvestimento"
                    [exibirEnviarBoleto]="exibirEnviarBoleto"
                    [exibirAtivacao]="exibirAtivacao"
                    [exibirDesativacao]="exibirDesativacao"
                    [isRodadaInvestimento]="isRodadaInvestimento"
                    [isAssessor]="isAssessor"
                    (acaoCrud)="executarAcaoCrud($event.acaoCrud, $event.objeto)"
                    (acaoExtra)="executarAcaoExtra($event.acaoExtra, $event.objeto)"
                    (acaoInvestimento)="executarAcaoInvestimento($event.acaoInvestimento, $event.investimento)">
                </app-coluna-acoes-crud>
            </td>
        </ng-container>

    <!--
      coluna com botões de troca de status para a lista de rodadas de investimento
      as input e output properties recebidas aqui são passadas para as
      input e output properties do componente da coluna de statuses
    -->
    <ng-container *ngIf="coluna.tipo === TipoColuna.Statuses">
      <td mat-cell *matCellDef="let objeto" [attr.data-label]="coluna.nome">
        <app-coluna-statuses
          [objeto]="objeto"
          (trocaStatus)="executarTrocaDeStatus($event.novoStatus, $event.objeto)">
        </app-coluna-statuses>
      </td>
    </ng-container>

    <!-- coluna com botão de download de arquivo -->
    <ng-container *ngIf="coluna.tipo === TipoColuna.Arquivo">
      <td mat-cell *matCellDef="let objeto" [attr.data-label]="coluna.nome">
        <div class="actions-buttons">
          <a [href]="objeto.arquivo | safeUrl" target="_blank">
            <icons-primecap name="pdf"></icons-primecap>
          </a>
        </div>
      </td>
    </ng-container>

        <!-- exibir detalhes para objetos que precisam ser detalhados -->

        <div *ngIf="exibirMatSort; else colunaSemMatSort">
            <th id="{{ coluna.nome }}" mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="p-bold" *ngIf="exibirNomeColuna">
                    {{ coluna.nome }}
                </p>
            </th>
        </div>

        <ng-template #colunaSemMatSort class="teste">
            <th id="{{ coluna.nome }}" *matHeaderCellDef class="celula-header">
                <p class="p-bold" *ngIf="exibirNomeColuna">
                    {{ coluna.nome }}
                </p>
            </th>
        </ng-template>

        <div *ngIf="exibirDetalhes; else colunaSemDetalhes">
            <td mat-cell *matCellDef="let objeto" (click)="executarAcaoCrud(acoesCrud.Detalhes, objeto)" [attr.data-label]="coluna.nome" class="celula-com-detalhes">
                <app-celula-tabela
                    [objeto]="objeto"
                    [coluna]="coluna.prop"
                    [tipo]="coluna.tipo">
                </app-celula-tabela>
            </td>
        </div>

        <!-- exibir objetos sem detalhamento -->
        <ng-template #colunaSemDetalhes>
            <td mat-cell *matCellDef="let objeto" [attr.data-label]="coluna.nome" class="celula-sem-detalhes">
                <app-celula-tabela
                    [objeto]="objeto"
                    [coluna]="coluna.prop"
                    [tipo]="coluna.tipo">
                </app-celula-tabela>
            </td>
        </ng-template>

  </ng-container>

  <!-- em caso de objetos com detalhamento, modificar cursor e aplicar hover na linha -->
  <div *ngIf="exibirDetalhes; else linhaSemDetalhes">
    <tr mat-header-row *matHeaderRowDef="columnsProp"></tr>
    <tr class="linha-detalhes" mat-row *matRowDef="let row; columns: columnsProp;
      let i = index"
      [attr.id]="i">
    </tr>
  </div>

  <!-- em caso de objetos sem detalhes, manter a linha com o cursor padrão e sem hover -->
  <ng-template #linhaSemDetalhes>
    <tr mat-header-row *matHeaderRowDef="columnsProp"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsProp; let i = index"
      [attr.id]="i">
    </tr>
  </ng-template>

</table>
<mat-paginator *ngIf="exibirPaginador"
  (page)="mudarPagina($event)"
  [pageSize]="paginaConfig.pageSize"
  [length]="paginaConfig.length"
  [pageSizeOptions]="tamanhoPaginaPadrao" class="mat-paginator-sticky"
  showFirstLastButtons="true">
</mat-paginator>
